/*
 * color-manager-browse.js  (Phase 2)
 * Reusable Mobellia colour/fabric selector. Two modes:
 *   - browse  (/pages/colors): read-only detail view
 *   - select  (PDP drawer, Task 4): detail view gains "Velg denne fargen",
 *             which dispatches a `cm:select` CustomEvent on the root.
 * Data is the JSON dumped by color-manager-browse.liquid (collections -> colours).
 * Everything (filters, chips, options) is built from the data at runtime.
 */
(function () {
  'use strict';

  var PREVIEW_N = 5; // collapsed collections show this many cards + a "+N" tile
  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }
  function natcmp(a, b) { return String(a).localeCompare(String(b), 'nb', { numeric: true }); }
  function distinct(arr, key) { var s = {}; arr.forEach(function (x) { var v = (x[key] || '').trim(); if (v) s[v] = 1; }); return Object.keys(s); }
  function countBy(arr, key) { var s = {}; arr.forEach(function (x) { var v = (x[key] || '').trim(); if (v) s[v] = (s[v] || 0) + 1; }); return s; }

  function init(root) {
    if (root.dataset.cmReady) return; root.dataset.cmReady = '1';
    var mode = root.dataset.cmMode || 'browse';
    var dataEl = root.querySelector('[data-cm="data"]');
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var collections = (data.collections || []).slice().sort(function (a, b) { return natcmp(a.name, b.name); });
    collections.forEach(function (coll) { (coll.colours || []).forEach(function (c) { c._coll = coll; }); });
    var allColours = collections.reduce(function (a, c) { return a.concat(c.colours || []); }, []);
    var total = allColours.length;

    var q = function (n) { return root.querySelector('[data-cm="' + n + '"]'); };
    var ui = {
      results: q('results'), count: q('count'), empty: q('empty'), search: q('search'),
      family: q('family-chips'), selects: q('selects'), reset: q('reset'),
      modal: q('modal'), modalBody: q('modal-body'), filterToggle: q('filter-toggle'), bar: q('bar')
    };

    var state = { q: '', family: '', filters: {}, expanded: {} };

    // ---- colour-family chips (priority filter, full coverage) ----
    // Canonical representative hue per family so the dot always matches the
    // family name (the per-swatch hex is unreliable for a family indicator).
    var FAMILY_HEX = { 'Beige': '#cbb99b', 'Brun': '#6e4e37', 'Grå': '#9c988f', 'Sort': '#222120',
      'Hvit': '#f1eee8', 'Blå': '#36567c', 'Grønn': '#5a7048', 'Rød': '#9c2b27', 'Gul': '#d8b43c',
      'Oransje': '#c56a2c', 'Rosa': '#d08aa0', 'Lilla': '#6e5687', 'Multi': '#9c988f' };
    function famHexOf(f) { return FAMILY_HEX[f] || '#9c988f'; }
    var famCount = countBy(allColours, 'colour_family');
    Object.keys(famCount).sort(function (a, b) { return famCount[b] - famCount[a]; }).forEach(function (fam) {
      var chip = el('button', 'cm-chip'); chip.type = 'button'; chip.dataset.family = fam; chip.setAttribute('aria-pressed', 'false');
      chip.innerHTML = '<span class="cm-chip__dot" style="background:' + famHexOf(fam) + '"></span>' +
        '<span>' + fam + '</span><span class="cm-chip__n">' + famCount[fam] + '</span>';
      chip.addEventListener('click', function () { state.family = state.family === fam ? '' : fam; syncChips(); render(); });
      ui.family.appendChild(chip);
    });
    function syncChips() { [].forEach.call(ui.family.children, function (c) { c.setAttribute('aria-pressed', c.dataset.family === state.family ? 'true' : 'false'); }); }

    // ---- dropdown filters (shown only when >=2 distinct values) ----
    function addSelect(key, label, source, labelFn, order) {
      var arr = source === 'colour' ? allColours : collections;
      var values = distinct(arr, key);
      if (values.length < 2) return;
      var sel = el('select', 'cm-select');
      sel.appendChild(new Option(label, '')); // default option doubles as the label
      var sorted = order
        ? values.slice().sort(function (a, b) { var ia = order.indexOf(a), ib = order.indexOf(b); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || natcmp(a, b); })
        : values.sort(natcmp);
      sorted.forEach(function (v) { sel.appendChild(new Option(labelFn ? labelFn(v) : v, v.toLowerCase())); });
      sel.dataset.key = key; sel.dataset.source = source;
      sel.setAttribute('aria-label', label);
      sel.addEventListener('change', function () { state.filters[key] = sel.value; sel.classList.toggle('cm-select--on', !!sel.value); render(); });
      ui.selects.appendChild(sel);
    }
    addSelect('price_group', 'Stoffgruppe', 'collection', function (v) { return 'Stoffgruppe ' + v; });
    addSelect('use_level', 'Holdbarhet', 'collection', null, ['Normal bruk', 'Slitesterk', 'Svært slitesterk', 'Kontraktkvalitet']);
    addSelect('material', 'Materiale', 'collection');
    addSelect('lightness', 'Lyshet', 'colour');
    // use_level / cleaning_code / resistance auto-skipped (too few values)

    // ---- filtering ----
    function isFiltering() { return !!(state.q || state.family || Object.keys(state.filters).some(function (k) { return state.filters[k]; })); }
    function matches(c) {
      if (state.family && c.colour_family !== state.family) return false;
      if (state.q) { var hay = (c.name + ' ' + c._coll.name).toLowerCase(); if (hay.indexOf(state.q) === -1) return false; }
      for (var k in state.filters) {
        var val = state.filters[k]; if (!val) continue;
        var src = (k === 'lightness') ? c : c._coll;
        if ((String(src[k] || '')).toLowerCase() !== val) return false;
      }
      return true;
    }

    // ---- card / mini builders ----
    // Card built in JS (no dependency on a server-rendered <template>, which can
    // flake during concurrent theme deploys).
    function buildCard(c, showColl) {
      var card = el('article', 'cm-card'); card.tabIndex = 0; card.setAttribute('role', 'button'); card.setAttribute('aria-label', c.name);
      var media = el('div', 'cm-card__media');
      var img = el('img', 'cm-card__img'); img.loading = 'lazy'; img.decoding = 'async'; img.alt = 'Stoffprove: ' + c.name; if (c.swatch) img.src = c.swatch;
      var badge = el('span', 'cm-card__badge'); badge.textContent = 'Stoffgruppe ' + (c._coll.price_group || '-');
      media.appendChild(img); media.appendChild(badge);
      var name = el('h4', 'cm-card__name'); name.textContent = c.name;
      card.appendChild(media); card.appendChild(name);
      if (showColl) { var cl = el('span', 'cm-card__coll'); cl.textContent = c._coll.name; card.appendChild(cl); }
      card.addEventListener('click', function () { openDetail(c); });
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDetail(c); } });
      return card;
    }
    function buildMini(c) {
      var b = el('button', 'cm-mini'); b.type = 'button'; b.title = c.name;
      b.setAttribute('aria-label', c.name);
      var i = el('img', 'cm-mini__img'); i.loading = 'lazy'; i.alt = ''; if (c.swatch) i.src = c.swatch;
      b.appendChild(i);
      b.addEventListener('click', function (e) { e.stopPropagation(); openDetail(c); });
      return b;
    }

    // ---- render ----
    function render() {
      var filtering = isFiltering();
      ui.results.innerHTML = '';
      var shown = 0, shownColls = 0;

      // Filtered -> one flat dense grid (matches pack into full rows, no
      // per-collection empty space). Unfiltered -> collection accordion.
      if (filtering) {
        var matched = allColours.filter(matches);
        matched.sort(function (a, b) { return natcmp(a._coll.name, b._coll.name) || natcmp(a.name, b.name); });
        shown = matched.length;
        shownColls = Object.keys(matched.reduce(function (s, c) { s[c._coll.name] = 1; return s; }, {})).length;
        var fgrid = el('div', 'cm-grid cm-grid--flat');
        matched.forEach(function (c) { fgrid.appendChild(buildCard(c, true)); });
        ui.results.appendChild(fgrid);
        updateCount(shown, shownColls, true);
        ui.empty.hidden = shown !== 0;
        return;
      }

      var frag = document.createDocumentFragment();
      collections.forEach(function (coll) {
        var cols = coll.colours || [];
        var matched = cols;
        shownColls++; shown += matched.length;

        var sec = el('section', 'cm-coll');
        var open = filtering || state.expanded[coll.name];

        var head = el('button', 'cm-coll__head'); head.type = 'button'; head.setAttribute('aria-expanded', open ? 'true' : 'false');
        head.innerHTML =
          '<span class="cm-coll__title">' + coll.name + '</span>' +
          (coll.price_group ? '<span class="cm-badge">Stoffgruppe ' + coll.price_group + '</span>' : '') +
          (coll.material ? '<span class="cm-coll__meta">' + coll.material + '</span>' : '') +
          '<span class="cm-coll__count">' + (filtering ? matched.length + ' av ' + cols.length : cols.length) + ' farger</span>' +
          '<svg class="cm-chev" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
        if (!filtering) head.addEventListener('click', function () { state.expanded[coll.name] = !state.expanded[coll.name]; render(); });
        sec.appendChild(head);

        // Uniform: collapsed shows a preview of the SAME compact cards + a "+N"
        // tile; expanded shows them all. One consistent card style throughout.
        var body = el('div', 'cm-coll__body');
        var grid = el('div', 'cm-grid');
        var preview = open ? cols : cols.slice(0, PREVIEW_N);
        preview.forEach(function (c) { grid.appendChild(buildCard(c)); });
        if (!open && cols.length > PREVIEW_N) {
          var more = el('button', 'cm-more'); more.type = 'button';
          more.innerHTML = '<span class="cm-more__plus">+' + (cols.length - PREVIEW_N) + '</span><span class="cm-more__tx">Vis alle</span>';
          more.setAttribute('aria-label', 'Vis alle ' + cols.length + ' farger i ' + coll.name);
          more.addEventListener('click', function (e) { e.stopPropagation(); state.expanded[coll.name] = true; render(); });
          grid.appendChild(more);
        }
        body.appendChild(grid);
        sec.appendChild(body);
        frag.appendChild(sec);
      });

      ui.results.appendChild(frag);
      ui.empty.hidden = shown !== 0;
      updateCount(shown, shownColls, false);
    }

    function updateCount(shown, shownColls, filtering) {
      ui.count.innerHTML = 'Viser <b>' + shown + '</b> av <b>' + total + '</b> farger i <b>' + shownColls + '</b> kolleksjoner' +
        (filtering ? ' <button type="button" class="cm-clearlink" data-cm="reset-inline">Nullstill</button>' : '');
      var ri = ui.count.querySelector('[data-cm="reset-inline"]'); if (ri) ri.addEventListener('click', resetAll);
    }

    // ---- detail modal ----
    function spec(label, value) { return value ? '<div class="cm-spec"><dt>' + label + '</dt><dd>' + value + '</dd></div>' : ''; }
    function flag(label, on) { return on === true ? '<span class="cm-flag">' + label + '</span>' : ''; }
    function openDetail(c) {
      var coll = c._coll;
      var html =
        '<div class="cm-detail">' +
          '<div class="cm-detail__media"><img src="' + (c.swatch || '') + '" alt="Stoffprove: ' + c.name + '"></div>' +
          '<div class="cm-detail__info">' +
            '<p class="cm-detail__eyebrow">' + coll.name + (coll.supplier ? ' &middot; ' + coll.supplier : '') + '</p>' +
            '<h3 class="cm-detail__name">' + c.name + '</h3>' +
            '<div class="cm-detail__tags">' +
              (c.colour_family ? '<span class="cm-tag"><span class="cm-chip__dot" style="background:' + famHexOf(c.colour_family) + '"></span>' + c.colour_family + '</span>' : '') +
              '<span class="cm-tag">Stoffgruppe ' + (coll.price_group || '-') + '</span>' +
              (c.lightness ? '<span class="cm-tag">' + c.lightness + '</span>' : '') +
            '</div>' +
            '<dl class="cm-specs">' +
              spec('Materiale', coll.material) +
              spec('Bruksnivå', coll.use_level) +
              spec('Holdbarhet', coll.durability_martindale) +
              spec('Sammensetning', coll.composition) +
              spec('Vekt', coll.weight_gsm) +
              spec('Nupping', coll.pilling) +
              spec('Lysekthet', coll.lightfastness) +
              spec('Rengjøring', coll.cleaning_code) +
            '</dl>' +
            '<div class="cm-flags">' + flag('Dyrevennlig', coll.pet_resistant) + flag('Flekkbestandig', coll.stain_resistant) + flag('Vannavstøtende', coll.water_repellent) + '</div>' +
            (mode === 'select' ? '<button type="button" class="cm-cta" data-cm="choose">Velg denne fargen</button>' : '') +
            (mode === 'browse' && coll.supplier ?
              '<a class="cm-detail__shop" target="_blank" rel="noopener" href="/collections/all?filter.p.m.mobellia.supplier=' + encodeURIComponent(coll.supplier) +
              '&farge=' + encodeURIComponent(c.name) + '&sw=' + encodeURIComponent(c.swatch || '') + '">' +
              'Vis møbler du kan bestille i denne fargen' +
              '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17 17 7"/><path d="M7 7h10v10"/></svg></a>' : '') +
          '</div>' +
        '</div>';
      ui.modalBody.innerHTML = html;
      var choose = ui.modalBody.querySelector('[data-cm="choose"]');
      if (choose) choose.addEventListener('click', function () {
        root.dispatchEvent(new CustomEvent('cm:select', { bubbles: true, detail: { colour: c, collection: coll } }));
        closeModal();
      });
      ui.modal.hidden = false; document.documentElement.style.overflow = 'hidden';
      ui.modal.querySelector('[data-cm="modal-close"]').focus();
    }
    function closeModal() { ui.modal.hidden = true; document.documentElement.style.overflow = ''; }

    // ---- events ----
    var t;
    if (ui.search) ui.search.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { state.q = ui.search.value.trim().toLowerCase(); render(); }, 110); });
    if (ui.reset) ui.reset.addEventListener('click', resetAll);
    function resetAll() {
      state.q = ''; state.family = ''; state.filters = {};
      if (ui.search) ui.search.value = '';
      [].forEach.call(ui.selects.querySelectorAll('select'), function (s) { s.value = ''; });
      syncChips(); render();
    }
    ui.modal.addEventListener('click', function (e) { if (e.target === ui.modal || e.target.closest('[data-cm="modal-close"]')) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ui.modal.hidden) closeModal(); });
    if (ui.filterToggle) ui.filterToggle.addEventListener('click', function () { root.classList.toggle('cm-filters-open'); });

    render();
  }

  function boot() { document.querySelectorAll('.cm-root[data-cm-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.CMBrowse = { init: init, boot: boot };
})();
